import { createContext, useContext, useEffect, useRef, useState } from "react";
import { Square } from "lucide-react";
import { playLive } from "../components/public/LivePlayer";

const Ctx = createContext(null);

export const RadioProvider = ({ children }) => {
  const audio = useRef(null);
  const hls = useRef(null);
  const [station, setStation] = useState(null);
  const [state, setState] = useState("idle");
  const [volume, setVolume] = useState(0.8);

  useEffect(() => {
    if (audio.current) audio.current.volume = volume;
  }, [volume]);

  const play = (s) => {
    setStation(s);
    setState("loading");
    playLive(audio.current, s.audio_url, hls, () => setState("error")).then(() => setState("playing")).catch(() => setState("error"));
  };
  const stop = () => {
    audio.current.pause();
    hls.current?.destroy();
    hls.current = null;
    setState("idle");
  };

  return (
    <Ctx.Provider value={{ station, state, play, stop, volume, setVolume }}>
      {children}
      {station && state !== "idle" && (
        <div className="fixed bottom-20 lg:bottom-4 left-4 z-[60] flex items-center gap-3 rounded-full pl-1.5 pr-2 py-1.5 bg-[#0e0b04] gold-frame-sm shadow-2xl no-print" data-testid="now-playing-bar">
          <img src={station.logo} alt={station.name} className="w-8 h-8 rounded-full bg-white object-cover" />
          <div className="leading-tight pr-1">
            <div className="text-[11px] text-white font-semibold">{station.name} · {station.freq}</div>
            <div className="font-data text-[9px] uppercase tracking-wider text-[#f7e08f]">{state === "loading" ? "Tuning in…" : state === "error" ? "Offline at source" : "Live"}</div>
          </div>
          <button onClick={stop} className="w-8 h-8 rounded-full gold-foil flex items-center justify-center" aria-label="Stop radio" data-testid="now-playing-stop-btn"><Square size={12} className="text-[#1b1305] fill-[#1b1305]" /></button>
        </div>
      )}
      <audio ref={audio} preload="none" data-testid="global-radio-audio" />
    </Ctx.Provider>
  );
};

export const useRadio = () => useContext(Ctx);
